export function getCurrencySymbol(currencyIso: string) {
  const options = { style: "currency", currency: currencyIso } as const;
  return new Intl.NumberFormat("en-US", options)
    .formatToParts(1)
    .find((x) => x.type === "currency").value;
}

export function formatCurrency(amount: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount);
}
